import React from 'react';
import { useMutation } from '@apollo/client';

/**
 * Small compatibility wrapper to replace `react-apollo`'s <Mutation> render-prop component.
 * Now backed by @apollo/client hooks.
 */
export default function Mutation({
  mutation,
  refetchQueries,
  children,
  ...options
}) {
  const [mutate, result] = useMutation(mutation, {
    refetchQueries,
    ...options
  });

  return children(mutate, result);
}
